export const hideCpf = (cpf: string) => {
  const cleanCPF = cpf.replace(/\D/g, "");

  if (cleanCPF.length !== 11) {
    return "";
  }

  return `***.***.*${cleanCPF.slice(7, 9)}-${cleanCPF.slice(9, 11)}`;
};

export const hideCnpj = (cnpj: string) => {
  if (cnpj.length !== 14) {
    return cnpj;
  }
  const firstTwo = cnpj.slice(0, 2);
  const lastTwo = cnpj.slice(-2);
  const middle = ".***.***/****-";

  return `${firstTwo}${middle}${lastTwo}`;
};

export const formatCNPJ = (cnpj: string) => {
  const v = cnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  if (v.length !== 14) return cnpj;
  return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8, 12)}-${v.slice(12, 14)}`;
};

export const toInputDateString = (date: Date | string) => {
  date = date instanceof Date ? date : new Date(date);
  return `${date.toLocaleDateString("pt-BR", {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
  })} - ${date.toLocaleTimeString([], {
    hour12: false,
  })}`;
};

export const roundValue = (value: number) => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

export const toDateAndTime = (date: string) => {
  const adjustedDate = !date.endsWith("Z") ? `${date}Z` : date;
  return `${new Date(adjustedDate).toLocaleDateString([], {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
  })} - ${new Date(adjustedDate).toLocaleTimeString([], {
    hour12: false,
  })}`;
};

export const hexToRGBA = (hex: string, alpha: number) => {
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);
  const rgba = `rgba(${r}, ${g}, ${b}, ${alpha})`;
  return rgba;
};

export function moneyMask(value: number) {
  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export const cpfMask = (cpf: string) => {
  return cpf
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};

export const cnpjMask = (cnpj: string) => {
  const v = cnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  if (v.length <= 2) return v;
  if (v.length <= 5) return `${v.slice(0, 2)}.${v.slice(2)}`;
  if (v.length <= 8) return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5)}`;
  if (v.length <= 12) return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8)}`;
  return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8, 12)}-${v.slice(12, 14)}`;
};

export const validateCPF = (strCPF: string) => {
  var Soma;
  var Resto;
  Soma = 0;
  if (strCPF === "00000000000") return false;
  if (strCPF === "11111111111") return false;
  if (strCPF === "22222222222") return false;
  if (strCPF === "33333333333") return false;
  if (strCPF === "44444444444") return false;
  if (strCPF === "55555555555") return false;
  if (strCPF === "66666666666") return false;
  if (strCPF === "77777777777") return false;
  if (strCPF === "88888888888") return false;
  if (strCPF === "99999999999") return false;

  for (let i = 1; i <= 9; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
  return true;
};

// ASCII - 48: '0'-'9' → 0-9, 'A'-'Z' → 17-42 (IN RFB nº 2.229/2024)
const cnpjCharValue = (char: string): number => char.toUpperCase().charCodeAt(0) - 48;

const CNPJ_WEIGHTS_1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_WEIGHTS_2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export const validateCNPJ = (cnpj: string) => {
  const v = cnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

  if (v.length !== 14) return false;

  // Rejeita sequências de caracteres idênticos
  if (/^(.)\1+$/.test(v)) return false;

  const calcDigit = (base: string, weights: number[]): number => {
    const soma = base.split("").reduce((acc, char, i) => acc + cnpjCharValue(char) * weights[i], 0);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  if (calcDigit(v.substring(0, 12), CNPJ_WEIGHTS_1) !== cnpjCharValue(v.charAt(12))) return false;
  if (calcDigit(v.substring(0, 13), CNPJ_WEIGHTS_2) !== cnpjCharValue(v.charAt(13))) return false;

  return true;
};

export const isNullOrEmpty = (value: string | null | undefined) => {
  return value === null || value === undefined || value.trim() === "";
};